var base = require('base_global/product/base');

export default {
    ...base

};